export default __webpack_public_path__ + "3b7a27008173d95317626e3baf0c0263.svg";